import { Autocomplete, Box, Button, Paper, TextareaAutosize, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import './SmartTrigger.css';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

const smartTriggerTypes:string[] = ["Sms","App Notification"];
const smartTriggerOptions: string[] = [
    "User logged in but not ordered for N days",
    "Find not logged in user for N days and send app notification",
    "Smart trigger for applying a specific notification template with specific user (For Testing the notification templates)",
    "Find not ordered users and send notification",
    "Find all outlet retailers and send notification"
]
const templates: string[] = [
    "Users-who-have-logged-in-but-not-yet-placed-any-orders-in-the-last-N-days",
    "User-logged-in-past-N-days",
    "User-not-logged-in-users-for-N-days",
    "not-logged-in-users"
]
function SmartTriggger() {
  const [ smartTriggerOption, setSmartTriggerOption] = useState<string | null>("");
  const handleSmartTriggerOption = (event:any,value: string | null) => {
    setSmartTriggerOption(value);
    console.log(value);  
  }
  const [ template, setTemplate] = useState<string | null>("");
  const handleTemplate = (event:any,value: string | null) => {
    setTemplate(value);
    // console.log(value);  
  }
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Smart Trigger"
  return (
    <Paper style={{ height: "100%", overflow: "auto", marginTop: "18px", backgroundColor: "#f0f0f2", padding: "10px"}}>
        <Box sx= {{ boxShadow: 3 , marginTop: "18px", padding: "20px"}} bgcolor="white" width="100%">
        <div className='boxHeading'><Typography variant="h6" pl={2} sx={{ fontSize: "19px", fontWeight: "600"}}>{translate(TranslationEnum.smart_trigger,"Smart Trigger")}</Typography></div>
        <Autocomplete
                className='roundedInputs'
                disablePortal
                id="smartTriggerType"
                sx={{ marginTop: "20px", borderRadius: "5px" }}
                options={smartTriggerTypes}
                onChange={()=>{}}
                renderInput={(params) => <TextField {...params}  label={translate(TranslationEnum.smart_trigger,"Select Banner Template")} />}
            />
         <Autocomplete
                className='roundedInputs'
                disablePortal
                id="smartTriggerOption"
                options={smartTriggerOptions}
                onChange={handleSmartTriggerOption}
                renderInput={(params) => <TextField {...params} label={translate(TranslationEnum.smart_trigger,"Select Banner Template")} />}
            />
            {smartTriggerOption? <><Autocomplete
                    className='roundedInputs'
                    disablePortal
                    id="smartTriggerOption"
                    options={templates}
                    onChange={handleTemplate}
                    renderInput={(params) => <TextField {...params} label={translate(TranslationEnum.smart_trigger,"Select Banner Template")} />}
                />

                <FormControl sx={{ margin: "5px"}}>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                    >
                        <FormControlLabel value="scheduleNow" control={<Radio />} label="Schedule Now" />
                        <FormControlLabel value="scheduleLater" control={<Radio />} label="Schedule Later" />
                        <FormControlLabel value="scheduleOnEvent" control={<Radio />} label="Schedule on Event" />
                    </RadioGroup>
                </FormControl>
                <TextField id="loginId" label="LoginId*" variant="outlined" />
            </>
            :<></>}
            <div className='buttonsContainer'>
                <Button
                    style={{
                        marginLeft: "10px",
                        padding: "0.5rem 1.6rem",
                        fontSize: "0.64rem",
                        backgroundColor: "#02bbd5",
                    }}
                    variant="contained"
                >
                    {translate(TranslationEnum.smart_trigger,"TRIGGER NOW")}
                </Button>
            </div>
        </Box>  
    </Paper>
  )
}

export default SmartTriggger
